import React, { Fragment, useEffect, useState } from 'react';
import { trackClickEventProp54, trackViewEvent } from '../../../utils/omnitureUtils.js';
import BusListing from './BookListing';
import { BookABusData } from './data.js';
import '../../../styles/BookABus.css';

type BookABus = {
  source: string;
  destination: string;
};

const BookABus = ({ source, destination }: BookABus) => {
  const [busList, setBusList] = useState(false);
  const { offer, perf, point, ctaText } = BookABusData;

  const handleBusList = () => {
    if (busList) {
      trackClickEventProp54('trains_seo_route_cp_sidebar_closed');
    } else trackClickEventProp54('trains_seo_route_cp_cta_clicked');
    setBusList(!busList);
  };

  useEffect(() => {
    trackViewEvent('trains_seo_route_cp_visible');
  }, []);

  return (
    <Fragment>
      <div className="bookABusWrap" onClick={handleBusList}>
        <span className="busListSprite busIcon appendRight20"> &nbsp;</span>
        <div className="makeFlex column">
          <p className="offerTitle font18 latoBlack appendBottom15">
            {`Take a look at the best in class buses from ${source} to ${destination} starting from ₹560`}
          </p>
          <ul className="makeFlex font16 darkGreyText latoBold">
            <li className="makeFlex hrtlCenter appendRight20">
              <span className="busListSprite excOfrIcon appendRight10" />
              {offer}
            </li>
            <li className="makeFlex hrtlCenter appendRight20">
              <span className="busListSprite oneTimeIcon appendRight10" />
              {perf}
            </li>
            <li className="makeFlex hrtlCenter">
              <span className="busListSprite point2Icon appendRight10" />
              {point}
            </li>
          </ul>
        </div>
        <span
          className="pushRight font16 latoBold makeFlex hrtlCenter deepskyBlueText cursorPointer"
          onClick={handleBusList}
        >
          {ctaText}
          <span className="busListSprite rightArrowIcon appendLeft10" />
        </span>
      </div>

      {busList && (
        <Fragment>
          <BusListing close={handleBusList} source={source} destination={destination} />
          <div className="listBackdrop" onClick={() => handleBusList()}>
            &nbsp;
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default BookABus;
